module.exports = __webpack_public_path__ + "img/album21_08.56cce7e8.jpg";